export {};

$(document).on('click', '.block-title__mobile-toggle', function onClick(evt) {
    const $toggle = $(this);
    const $title = $toggle.closest('.block-title');

    $title.toggleClass('collapsed--mobile');

    $(window).trigger(NLMK.events.TABS_CHANGE);

    evt.preventDefault();
});



// WEBPACK FOOTER //
// ./js/main/module/block-title-toggle.js